import { AbstractControl, ValidatorFn } from '@angular/forms';

export function InstallSpaceMoreThanZeroSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any } => {
    return Number.parseInt(control.value) <= 0 ? { InstallSpaceMoreThanZeroSpaces : true} : null;
  };
}

